module.exports = __webpack_public_path__ + "static/biennale-regular-it-e525533510e5b68b4534515edc2f8913.otf";